import api from './api'

export const caseStudyService = {
  // Get all case studies
  getAll: async () => {
    const response = await api.get('/case-studies')
    return response.data
  },

  // Get single case study
  getById: async (id) => {
    const response = await api.get(`/case-studies/${id}`)
    return response.data.case_study
  },

  // Get case studies by module
  getByModule: async (moduleId) => {
    const response = await api.get(`/case-studies?module_id=${moduleId}`)
    return response.data
  },

  // Submit case study
  submit: async (id, submissionData) => {
    const response = await api.post(`/case-studies/${id}/submit`, submissionData)
    return response.data
  },

  // Update progress
  updateProgress: async (id, progressData) => {
    const response = await api.post(`/case-studies/${id}/progress`, progressData)
    return response.data
  },
}
